
export interface Rect {
  left: number;
  right: number;
  top: number;
  bottom: number;
};

export interface RectOffsets {
  left?: number;
  right?: number;
  top?: number;
  bottom?: number;
};

export interface Point {
  x: number;
  y: number;
}

export function GetRectOffsets(value: number | RectOffsets): RectOffsets {
  if (typeof value === 'number') {
    return {
      left: value,
      right: value,
      top: value,
      bottom: value,
    };
  }

  return {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    ...value
  };
}

export function rectContains(rect: Rect, x: number, y: number);
export function rectContains(rect: Rect, point: Point);
export function rectContains(rect: Rect, other: Rect);
export function rectContains(rect: Rect, point: number | Point | Rect, y?: number) {
  let l, t, r, b;

  if (typeof point == 'number') {
    // Point check, with x and y arguments
    l = point;
    t = y;
    r = l;
    b = t;
  }
  else if ('left' in point) {
    // Rect check
    l = point.left;
    b = point.bottom;
    r = point.right;
    t = point.top;
  }
  else {
    // Point check, with x/y point argument
    l = point.x;
    t = point.y;
    r = l;
    b = t;
  }

  return l >= rect.left && r <= rect.right
      && t >= rect.top  && b <= rect.bottom;
}

export function rectIntersection(rect: Rect, other: Rect) {
  return !(rect.left   > other.right
        || rect.right  < other.left
        || rect.top    > other.bottom
        || rect.bottom < other.top);
}
